import React, { useEffect, useState } from 'react';
import { Dialog, SimpleDialog, T, Tabs } from '@colonist/ui';
import { getNestedTranslation, passThroughTranslation } from '@colonist/i18n';
import { EditProfileHeader } from './Parts/EditProfileHeader/EditProfileHeader.tsx';
import { EditProfileColorSelector } from './Parts/EditProfileColorSelector/EditProfileColorSelector.tsx';
import { EditProfileAvatarSelector } from './Parts/EditProfileAvatarSelector/EditProfileAvatarSelector.tsx';
import styles from './PlayerEditProfileDialog.module.scss';
/** Dialog to edit a player's avatar and color. */ export const PlayerEditProfileDialog = ({ open, username, icon, colors, selectedColor, onColorSelect, avatars, selectedAvatar, onAvatarSelect, onUsernameClick, shouldHideStoreActions, onGoToStoreColors, onGoToStoreAvatars, onClose, initialTab })=>{
    const [activeTab, setActiveTab] = useState(initialTab);
    const [storePrompt, setStorePrompt] = useState(undefined);
    useEffect(()=>{
        setActiveTab(initialTab);
        setStorePrompt(undefined);
    }, [
        open,
        initialTab
    ]);
    const getMoreLabel = activeTab == 'avatar' ? {
        key: 'strings:homePage.header.avatarSelector.getMoreAvatars'
    } : {
        key: 'strings:homePage.header.defaultColorSelector.getMoreColors'
    };
    const isAvatarPrompt = (storePrompt === null || storePrompt === void 0 ? void 0 : storePrompt.tab) == 'avatar';
    const storePromptTitle = isAvatarPrompt ? {
        key: 'strings:homePage.header.avatarSelector.youDoNotOwnThisItem'
    } : {
        key: 'strings:homePage.header.defaultColorSelector.youDoNotOwnThisColor'
    };
    var _storePrompt_name;
    const storePromptName = (_storePrompt_name = storePrompt === null || storePrompt === void 0 ? void 0 : storePrompt.name) !== null && _storePrompt_name !== void 0 ? _storePrompt_name : passThroughTranslation('');
    const colorPromptBody = (storePrompt === null || storePrompt === void 0 ? void 0 : storePrompt.freeAtStore) ? getNestedTranslation({
        key: 'strings:homePage.header.defaultColorSelector.getColorForFree'
    }, {
        color: storePromptName
    }) : getNestedTranslation({
        key: 'strings:homePage.header.storePurchaseColorPrompt'
    }, {
        color: storePromptName
    });
    const storePromptBody = isAvatarPrompt ? getNestedTranslation({
        key: 'strings:homePage.header.storePurchaseIconPrompt'
    }, {
        iconName: storePromptName
    }) : colorPromptBody;
    const goToActiveStore = ()=>{
        switch(activeTab){
            case 'avatar':
                onGoToStoreAvatars();
                break;
            case 'color':
                onGoToStoreColors();
                break;
        }
    };
    const visibleColors = shouldHideStoreActions ? colors.filter((colorOption)=>!colorOption.disabled) : colors;
    const visibleAvatars = shouldHideStoreActions ? avatars.filter((avatarOption)=>!avatarOption.disabled) : avatars;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose,
        size: "sm"
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.header.editProfile'
        }
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement(EditProfileHeader, {
        username: username,
        icon: icon,
        onEditClick: ()=>onUsernameClick(activeTab)
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles.content
    }, /*#__PURE__*/ React.createElement(Tabs, {
        activeTabId: activeTab,
        onTabChange: setActiveTab,
        variant: "textOnly",
        scrollDirection: "horizontal",
        tabPosition: "top"
    }, /*#__PURE__*/ React.createElement(Tabs.Tab, {
        id: "avatar",
        label: {
            key: 'strings:storePage.sections.avatar.title',
            options: {
                context: 'one'
            }
        }
    }, /*#__PURE__*/ React.createElement(EditProfileAvatarSelector, {
        avatars: visibleAvatars,
        selectedAvatar: selectedAvatar,
        onAvatarSelect: onAvatarSelect,
        onDisabledAvatarSelect: (avatarId)=>{
            if (shouldHideStoreActions) return;
            const avatar = avatars.find((avatarOption)=>avatarOption.avatarId == avatarId);
            if (avatar == undefined) return;
            setStorePrompt({
                tab: 'avatar',
                name: avatar.name,
                freeAtStore: false
            });
        }
    })), /*#__PURE__*/ React.createElement(Tabs.Tab, {
        id: "color",
        label: {
            key: 'strings:storePage.sections.color.title',
            options: {
                context: 'one'
            }
        }
    }, /*#__PURE__*/ React.createElement(EditProfileColorSelector, {
        colors: visibleColors,
        selectedColor: selectedColor,
        onColorSelect: onColorSelect,
        onDisabledColorSelect: (colorId)=>{
            if (shouldHideStoreActions) return;
            const color = colors.find((colorOption)=>colorOption.colorId == colorId);
            if (color == undefined) return;
            setStorePrompt({
                tab: 'color',
                name: color.name,
                freeAtStore: color.freeAtStore
            });
        }
    }))))), !shouldHideStoreActions && /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        onClick: goToActiveStore
    }, /*#__PURE__*/ React.createElement(T, {
        id: getMoreLabel
    })))), /*#__PURE__*/ React.createElement(SimpleDialog, {
        open: !shouldHideStoreActions && storePrompt != undefined,
        onClose: ()=>setStorePrompt(undefined),
        title: storePromptTitle,
        body: storePromptBody,
        onConfirm: isAvatarPrompt ? onGoToStoreAvatars : onGoToStoreColors,
        showCancelBtn: true
    }));
};
